import { BASE_ROUTES } from './BASE';
import { PARAMS } from './PARAMS';

function routeBuilder(...rest: string[]) {
	return `/${rest.join('/')}`;
}

export const FULL_ROUTES = {
	ADD_APP: routeBuilder(BASE_ROUTES.APPLICATION_MONITORING, BASE_ROUTES.APPLICATION_SETUP, BASE_ROUTES.ADD_APP),
	ADMIN: routeBuilder(BASE_ROUTES.ADMIN),
	API_VOLUME: routeBuilder(BASE_ROUTES.APPLICATION_MONITORING, BASE_ROUTES.API_VOLUME),
	APPLICATION_MONITOR: routeBuilder(BASE_ROUTES.APPLICATION_MONITORING, BASE_ROUTES.APPLICATION_SETUP, PARAMS.ID),
	APPLICATION_MONITORING: routeBuilder(BASE_ROUTES.APPLICATION_MONITORING),
	APPLICATION_SETUP: routeBuilder(
		BASE_ROUTES.APPLICATION_MONITORING, BASE_ROUTES.APPLICATION_SETUP
	),
	CONFIRM_LINK: routeBuilder(BASE_ROUTES.CONFIRM_LINK),
	DASHBOARD: routeBuilder(BASE_ROUTES.DASHBOARD),
	DATA_ACCESS: routeBuilder(BASE_ROUTES.DATA_SECURITY, BASE_ROUTES.DATA_ACCESS),
	DATA_ACCESS_ACCESS_AUDIT: routeBuilder(
		BASE_ROUTES.DATA_SECURITY, BASE_ROUTES.DATA_ACCESS, BASE_ROUTES.ACCESS_AUDIT, PARAMS.OBJECT_ID
	),
	DATA_ACCESS_ACCESS_COMPARE: routeBuilder(
		BASE_ROUTES.DATA_SECURITY, BASE_ROUTES.DATA_ACCESS, BASE_ROUTES.ACCESS_COMPARISON
	),
	DATA_ACCESS_ACCESS_COMPARE_FIELDS: routeBuilder(
		BASE_ROUTES.DATA_SECURITY, BASE_ROUTES.DATA_ACCESS, BASE_ROUTES.ACCESS_COMPARISON, PARAMS.OBJECT_ID
	),
	DATA_ACCESS_ACCESS_EXPLAINER: routeBuilder(
		BASE_ROUTES.DATA_SECURITY, BASE_ROUTES.DATA_ACCESS, BASE_ROUTES.ACCESS_EXPLAINER, PARAMS.ID
	),
	DATA_ACCESS_ACCESS_EXPLAINER_FIELDS: routeBuilder(
		BASE_ROUTES.DATA_SECURITY,
		BASE_ROUTES.DATA_ACCESS,
		BASE_ROUTES.ACCESS_EXPLAINER,
		PARAMS.ID,
		PARAMS.OBJECT_ID
	),
	DATA_DICTIONARY: routeBuilder(BASE_ROUTES.DATA_DICTIONARY),
	EXPORT: routeBuilder(BASE_ROUTES.EXPORT, PARAMS.ID),
	FORGOT_PASSWORD: routeBuilder(BASE_ROUTES.FORGOT_PASSWORD),
	INITIATIVES: routeBuilder(BASE_ROUTES.INITIATIVES),
	INITIATIVES_DETAIL: routeBuilder(BASE_ROUTES.INITIATIVES, PARAMS.ID),
	INTEGRATIONS_OIDC: routeBuilder(BASE_ROUTES.INTEGRATIONS, BASE_ROUTES.OIDC),
	INTEGRATIONS_SALESFORCE: routeBuilder(BASE_ROUTES.INTEGRATIONS, BASE_ROUTES.SALESFORCE),
	INVITATION: routeBuilder(BASE_ROUTES.INVITATION, PARAMS.TOKEN),
	ISSUES: routeBuilder(BASE_ROUTES.ISSUES),
	ISSUES_ARCHIVED: routeBuilder(BASE_ROUTES.ISSUES, BASE_ROUTES.ARCHIVED),
	ISSUES_SNOOZED: routeBuilder(BASE_ROUTES.ISSUES, BASE_ROUTES.SNOOZED),
	LOGIN: routeBuilder(BASE_ROUTES.LOGIN),
	LOGIN_SSO: routeBuilder(BASE_ROUTES.LOGIN, BASE_ROUTES.SSO),
	MONITORS: routeBuilder(BASE_ROUTES.MONITORS_AND_LOGS, BASE_ROUTES.MONITORS),
	ONBOARDING_CONFIRM: routeBuilder(BASE_ROUTES.ONBOARDING, BASE_ROUTES.CONFIRM),
	ONBOARDING_CONNECT: routeBuilder(BASE_ROUTES.ONBOARDING, BASE_ROUTES.CONNECT),
	ONBOARDING_SYNC: routeBuilder(BASE_ROUTES.ONBOARDING, BASE_ROUTES.SYNC),
	ORGANIZATION_CONFIRM: routeBuilder(BASE_ROUTES.ORGANIZATION, BASE_ROUTES.CONFIRM),
	ORGANIZATION_SYNC: routeBuilder(BASE_ROUTES.ORGANIZATION, BASE_ROUTES.SYNC),
	PERISCOPE: routeBuilder(BASE_ROUTES.PERISCOPE),
	RESET_PASSWORD: routeBuilder(BASE_ROUTES.RESET_PASSWORD, PARAMS.TOKEN),
	SELECT_ORGANIZATION: routeBuilder(BASE_ROUTES.SELECT_ORGANIZTION),
	SETTINGS: routeBuilder(BASE_ROUTES.SETTINGS),
	SETTINGS_AGENT: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.AGENT_ACCESS),
	SETTINGS_AGENT_OAUTH_CONSENT: routeBuilder(BASE_ROUTES.SETTINGS,
		BASE_ROUTES.AGENT_ACCESS,
		BASE_ROUTES.OAUTH_CONSENT),
	SETTINGS_AI_CONTEXT: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.AI_CONTEXT),
	SETTINGS_DATA_DICTIONARY_API_KEYS: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.DATA_DICTIONARY_API_KEYS),
	SETTINGS_INTEGRATIONS: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.INTEGRATIONS),
	SETTINGS_JIRA: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.JIRA),
	SETTINGS_ORGANIZATION: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.ORGANIZATION),
	SETTINGS_SLACK: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.SLACK),
	SETTINGS_TEAM: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.TEAM),
	SETTINGS_USER: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.USER),
	SETUP_AUDIT_TRAIL: routeBuilder(BASE_ROUTES.MONITORS_AND_LOGS, BASE_ROUTES.SETUP_AUDIT_TRAIL),
	SHARED_VIEW: routeBuilder(BASE_ROUTES.SHARED_VIEW, PARAMS.ID),
	SIGN_UP: routeBuilder(BASE_ROUTES.SIGN_UP),
	SYNC: routeBuilder(BASE_ROUTES.SETTINGS, BASE_ROUTES.SYNC),
	TAGS: routeBuilder(BASE_ROUTES.TAGS),
	TAGS_MANAGE: routeBuilder(BASE_ROUTES.TAGS, BASE_ROUTES.MANAGE),
	TIMELINE: routeBuilder(BASE_ROUTES.MONITORS_AND_LOGS, BASE_ROUTES.TIMELINE),
	TOKEN: routeBuilder(BASE_ROUTES.TOKEN, PARAMS.TOKEN)
};
